const ALL_TREE_SELECT_OPTION_NODE = {
  title: 'All',
  value: '0',
  children: [],
}

export default ALL_TREE_SELECT_OPTION_NODE
